const UNITS_PER_LEVEL = 4

export const parseLevelNumber = (level: string): number | undefined => {
    const match = /^L(\d+)$/i.exec(level.trim())
    return match ? Number(match[1]) : undefined
}

export const parseUnitNumber = (unitNumber: string | undefined): number | undefined => {
    if (unitNumber === undefined || unitNumber.trim() === '') {
        return undefined
    }

    const parsed = Number(unitNumber.trim())
    return Number.isNaN(parsed) ? undefined : parsed
}

export const getFirstUnitNumberForLevel = (level: string): number | undefined => {
    const levelNumber = parseLevelNumber(level)
    if (levelNumber === undefined || levelNumber < 1) {
        return undefined
    }

    return (levelNumber - 1) * UNITS_PER_LEVEL + 1
}

export type StudentLevelInfo = {
    startLevel: string
    endLevel: string
    currentLevel: string
}

export const shouldShowLevelChangeRecommendation = (
    studentLevelInfo: StudentLevelInfo | undefined,
    classUnitNumber: number | undefined
): boolean => {
    if (!studentLevelInfo || classUnitNumber === undefined) {
        return false
    }

    if (studentLevelInfo.currentLevel !== studentLevelInfo.startLevel) {
        return false
    }

    const firstUnitNumber = getFirstUnitNumberForLevel(studentLevelInfo.startLevel)
    if (firstUnitNumber === undefined) {
        return false
    }

    return classUnitNumber === firstUnitNumber
}
